import { PageLocatorMap } from '../types/PageLocatorMap';

export const dashboardGaragePage = {
  alert: {
    error: 'dashboard-garage.alert.error',
  },
  footer: {
    root: 'dashboard-garage.footer',
  },
  header: {
    drawerButton: 'dashboard-garage.header.drawer-button',
    root: 'dashboard-garage.header',
  },
  main: {
    cardList: 'dashboard-garage.main.card-list',
    getCardListItem: (index: number) =>
      `dashboard-garage.main.card-list-item-${index + 1}`,
    h1: 'dashboard-garage.main.heading1',
    h2: 'dashboard-garage.main.heading2',
    h3: 'dashboard-garage.main.heading3',
    newApplicationButton: 'dashboard-garage.main.new-application-button',
    root: 'dashboard-garage.main',
  },
} as const satisfies PageLocatorMap;
